import type { NuxtApp } from "#app";
import { Keys, usePreferences } from "@/composables/usePreferences";

const { storeAssistantId, storeSettingsId } = useGlobalConfig();
const { getPreferences, setPreferences, removePreferences } = usePreferences();

export default defineAppConfig({
  sanctum: {
    tokenStorage: {
      get: async (app: NuxtApp) => {
        if (import.meta.server) return undefined;
        // @TODO Figure out how we can make sure to get the assistant ID before anything else. For
        // now it seems it's this place, but it seems random.
        storeAssistantId(app);
        storeSettingsId(app);
        // Get token from local storage
        const token = await getPreferences({
          key: Keys.token,
        });
        return token?.value ?? undefined;
      },

      set: async (app: NuxtApp, token?: string) => {
        if (import.meta.server) return;
        if (!token) {
          // Clear token from local storage
          await removePreferences({
            key: Keys.token,
          });
          return;
        }
        // Save token to local storage
        await setPreferences({
          key: Keys.token,
          value: token,
        });
      },
    },
  },
});
